// extracted by mini-css-extract-plugin
export default {"button":"style_button__qwb0-","tooltip":"style_tooltip__DiA8V"};